import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getAllBrand } from "../../../actions/Inventory/brandAction";
import Rendertable from "./Rendertable";

const List = ({ getAllBrand, List, updatelist, setUpdatelist }) => {
  useEffect(() => {
    getAllBrand();
    setUpdatelist(true);
  }, [updatelist, setUpdatelist]);

  return (
    <>
      <Rendertable List={List} setUpdatelist={setUpdatelist} />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    List: state.brand.brandlist,
  };
};

export default connect(mapStateToProps, {
  getAllBrand,
})(List);
